import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { PortalCredentials } from "../../../../models";

import { StringDetailedResponse } from "../../../../models/swagger/generated-submission-service";
import { PortalConfigurationService } from "../../../../services/ClientService";

export type CredentialsModalProps = {
    show: boolean;
    portalConfigId?: string;
    onClose: () => void;
};

export default function CredentialsModal({
    show,
    portalConfigId,
    onClose,
}: CredentialsModalProps) {
    const [data, setData] = useState([] as PortalCredentials);

    useEffect(() => {
        if (show === true) {
            PortalConfigurationService.getCredentials({
                portalConfigId: portalConfigId ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        setData(resp.data as PortalCredentials);
                    } else {
                        console.log("Error");
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [show]);

    const closeWindow = () => {
        setData([] as PortalCredentials);
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Portal Credentials
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>UserName</label>
                        <input
                            className="form-control"
                            id="feeRuleAttorneyID"
                            type="text"
                            value={data.username}
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>Password</label>
                        <input
                            className="form-control"
                            id="feeRuleCounty"
                            type="text"
                            value={data.password}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
